import { lookupVin } from '@/apiCalls/assetLookup';
import { getBorrower } from '@/apiCalls/borrower';
import { EModals, setIsAssetKnownViaParams, setModal } from '@/context/display';
import { store } from '@/context/store'; // Add this import
import {
    ELocalStorageVariables,
    getLocalStorageItem,
} from '@/utils/localStorage';

async function handleSavedAppData(): Promise<void> {
    // Replace hooks with direct store dispatch and selectors
    const dispatch = store.dispatch;
    const state = store.getState();
    const partnerId = state.displayReducer.partner.id;
    const glassValuation = state.borrowerReducer.vehicle.glassValuation;

    if (!glassValuation && partnerId && partnerId !== 'UNKNOWN') {
        await lookupVin(partnerId).then((isSuccessful) => {
            if (isSuccessful) {
                dispatch(setIsAssetKnownViaParams(true));
            }
        });
    }

    getBorrower();
    dispatch(setModal(null));
}

export function getInitialModalScreen(): EModals | null {
    const authToken = getLocalStorageItem(ELocalStorageVariables.AUTH_TOKEN);
    const firstName = getLocalStorageItem(ELocalStorageVariables.FIRST_NAME);

    if (authToken && firstName) {
        handleSavedAppData();
    }

    return null;
}
